import Loading from "../../../components/Loading"
import PropTypes from "prop-types"

/**
 * @template T
 * @typedef {React.FC<T & {isLoading: boolean}>} WithLoading
 */

/**
 * @template T
 * @param {React.FC<T>} WrappedComponent
 * @returns {React.FC<T & {isLoading: boolean}>}
 */
export const withLoading = (WrappedComponent) => {
  const HOCComponent = ({ isLoading, ...props }) =>
    isLoading ? <Loading className={"spinner-small"} /> : <WrappedComponent {...props} />

  HOCComponent.propTypes = {
    isLoading: PropTypes.bool
  }

  return HOCComponent
}
